// this needs to be the first import since it determines the cdn location of resources
import "./../src/publicPath.ts";

import "core-js/stable";
import "regenerator-runtime/runtime";
import "../src/helpers/polyfill";
import "../script/jquery.hoverintent.js";
import "../script/init_autocomplete.js";
import "../script/jquery.reveal.js";
import "../script/dropdown-menu.js";
import "../script/jquery.validate.js";
import "../script/countdown.js";
import "../script/jquery.lazyloadxt.js";
import "../script/jquery.lazyloadxt.srcset.js";
import "../script/shave.js";

var c = {
    config: {
        // Globale Settings
        filterList: true,
        CategoryId: 0,
        CategoryTypeId: 0,
        width: (window.innerWidth > 0) ? window.innerWidth : screen.width,
        lang: 'de',
        breakpointTablet: 481,
        breakpointTabletLarge: 768,
        breakpointDesktop: 940,
        breakpointDesktopLarge: 1120
    },
    storage: {
        get: function (id, fromSession) {
            fromSession = typeof fromSession !== 'undefined' ? fromSession : false;

            var item = fromSession ? sessionStorage.getItem(id) : localStorage.getItem(id);

            if (item === null) {
                return false;
            }

            return JSON.parse(item);
        },
        /*
         * Parameter: id, value
         */
        set: function (key, data, toSession) {
            toSession = typeof toSession !== 'undefined' ? toSession : false;
            var item = {
                value: data,
                created: new Date().getTime()
            };
            toSession ? sessionStorage.setItem(key, JSON.stringify(item)) : localStorage.setItem(key, JSON.stringify(item));
        }
    },
    tracking: {
        setVariable: function (key, value) {
            var dataLayer = window.dataLayer || [];
            var element = {};
            element[key] = value;
            dataLayer.push(element);
        },
        sendEvent: function (eventName) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({'event': eventName});
        },
        sendPromoClick: function (obj) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                'ecommerce': {
                    'promoClick': {
                        'promotions': [
                            {
                                'id': $(obj).data('ga-promo-linkid') || "Media" + $(obj).data('ga-promo-mediaid'),
                                'name': $(obj).data('ga-promo-name') || $(obj).find('img').attr('alt') || $(obj).text(),
                                'position': $(obj).data('ga-promo-position')
                            }
                        ]
                    }
                },
                'event': 'trackPromoClick'
            });
        },
        sendPromoImpression: function (obj) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                'ecommerce': {
                    'promoView': {
                        'promotions': [
                            {
                                'id': $(obj).data('ga-promo-linkid') || "Media" + $(obj).data('ga-promo-mediaid'),
                                'name': $(obj).data('ga-promo-name') || $(obj).find('img').attr('alt') || $(obj).text(),
                                'position': $(obj).data('ga-promo-position')
                            }
                        ]
                    }
                },
                'event': 'trackPromoImpressions'
            });
        }
    },
    sessionCookie: {
        get: function (key) {
            var name = key + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return false;
        },
        set: function (key, value) {
            document.cookie = key + '=' + value + ';path=/';
        },
        remove: function (key) {
            document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    },
    init: function (config) {
        var conf = this.config;

        // config Parameter einlesen
        $.extend(conf, config);

        // Hauptnavigation initialisieren
        c.mainNavigation.init();

        // Warenkorb/Kasse initialisieren
        c.cartFunctions.init();

        // Sprache des Form-Validators initialisieren
        c.initValidator.init(config.lang);

        // Externe Javascript-Links initialisieren (<span data-href-blank="http://...">)
        $('[data-href-blank]').on('click', function (e) {
            e.preventDefault();
            var newTab = window.open();
            newTab.opener = null;
            newTab.location = $(this).data('href-blank');
        });

        // Interne Javascript-Links initialisieren (<span data-href="http://...">)
        $('[data-href]:not(.button-disabled)').on('click', function (e) {
            e.preventDefault();
            window.location.href = $(this).data('href');
        });

        // "Akkordeon"-Aufklappbereiche initialisieren (zur Zeit nur auf Produktdetailseiten)
        $('.accordion .accordion__item__headline').on('click', function () {
            $(this).parent().toggleClass('active');
            c.tracking.sendEvent("PdsAccordionClicked");
        });

        // Formularfelder für Geburtstag initialisieren
        if ($('#Birthday').length) {
            this.initBirthday();
        }

        // Warenkorb-Mengenänderung
        var quantityTimer = null;
        $('.cart-item-quantity input').on('change', function () {
            var $this = $(this);
            if (quantityTimer !== null)
                clearTimeout(quantityTimer);
            quantityTimer = setTimeout(function () {
                $this.parents('form').first().submit();
            }, 750);
        });

        // Formular-Validierungs-Engine initialisieren
        var $forms = $('form.validate');
        if ($forms.length) {
            $forms.each(function () {
                $(this).validate({
                    errorPlacement: function (error, element) {
                        error.appendTo(element.parent());
                        return false;
                    },
                    ignore: ($(this).hasClass('validate-hidden') ? '' : ':hidden')
                });
            });
            $forms.find('.required input, .required select, .required textarea').each(function () {
                $(this).rules('add', {required: true})
            });
            $forms.find('#Password').each(function () {
                $(this).rules('add', {minlength: 8});
                $forms.find('#Password_Repeat').each(function () {
                    $(this).rules('add', {equalTo: '#Password'})
                });
            });
            $forms.find('#Password_New').each(function () {
                $(this).rules('add', {minlength: 8});
                $forms.find('#Password_Repeat').each(function () {
                    $(this).rules('add', {equalTo: '#Password_New'})
                });
            });
        }

        // Spezielle Behandlung bei der Newsletter-Anmeldung auf der Startseite
        var $newsletterSection = $('.section-newsletter-register-minimal__form');

        if ($newsletterSection.length) {
            var $requiredInputs = $newsletterSection.find('.connox-plus-div');

            $newsletterSection.find('input#ConnoxPlusCheckbox').on('change', function (evt) {
                addOrRemoveFormRequirement(evt.target.checked);
            });

            var addOrRemoveFormRequirement = function (isChecked) {
                var $inputs = $requiredInputs.find('input');
                if (isChecked) {
                    $requiredInputs.show(300);
                    $inputs.each(function () {
                        $(this).rules('add', {required: true});
                    });
                } else {
                    $requiredInputs.hide(300);
                    $inputs.each(function () {
                        $(this).rules('remove', 'required');
                    });
                }

            };

            // Falls Checkbox beim Laden gesetzt ist (z.B. bei vorherigem Klick auf 'zurück'
            if ($('input[name="Gender"]').val() == "F") {
                $('.genderbutton-left>button').addClass('active');
            } else if ($('input[name="Gender"]').val() == "M") {
                $('.genderbutton-right>button').addClass('active');
            }

            addOrRemoveFormRequirement($('input#ConnoxPlusCheckbox').checked);
        }

        // Aufklappbare Textblöcke initialisieren (für Hilfeseiten o.ä.)
        if ($('.drop-title').length && $('.drop-content').length) {
            c.dropDownText.init();
        }

        // Aufklappbare Contentblöcke initialisieren (für Footer o.ä.)
        $('.container').on('click', '.container__item--drawer .container__item__title', function () {
            $(this).parent().toggleClass('container__item--drawer-open');
        });

        // Ggf. Formular-Felder mittels Localstorage wieder befüllen
        if (localStorage) {
            c.formStorage(true);
        }

        // Liste der Artikelbewertungen initialisieren
        this.initProductReview();

        // Promobanner fixiert unten
        var $TopBarBottom = $('.top-bar--bottom');
        if ($TopBarBottom.length) {
            (function () {
                var thresh = 60;
                var $window = $(window);
                var visible = window.scrollY < thresh;
                if (!visible) $TopBarBottom.slideUp();
                $window.on('scroll', c.throttle(function () {
                    if (visible && window.scrollY >= thresh) {
                        $TopBarBottom.slideUp(200);
                        visible = !visible;
                    } else if (!visible && window.scrollY < thresh) {
                        $TopBarBottom.slideDown(200);
                        visible = !visible;
                    }
                }, 200));
            })();
        }

        // Toggle-Button (Mobilansicht) für Filterlisten initialisieren
        var $mobiletogglebutton = $('.mobile-toggle-button');
        if ($mobiletogglebutton.length) {
            $mobiletogglebutton.on('click', function () {
                $('.mobile-toggle').toggleClass('mobile-toggle-show');
                $('.mobile-toggle-button>span').toggleClass('svg-arrow-grey-down-16').toggleClass('svg-arrow-grey-up-16');
            })
        }

        // Löschformular im Kundenkonto initialisieren
        var $AccountDeletionForm = $('#AccountDeletionForm');
        if ($AccountDeletionForm.length) {
            c.accountDeletion($AccountDeletionForm);
        }

        // Special Offer Countdown
        this.specialOffer.init();

        // Blog-News
        this.blogNews.init();

        // Lese-Fortschritt initialisieren
        var $ProgressContainer = $('.progress-container');
        if ($ProgressContainer.length) {
            (function () {
                var $window = $(window);
                var $blogEntryTop = $('.blog-entry');
                var $blogEntryBottom = $('.blog-entry + section');

                var winHeight;
                var blog_entry_top;
                var blog_entry_bottom;
                var blog_height;

                var curr_abs_pos;
                var curr_blog_pos;
                var curr_value;
                var curr_percent_val;

                var visible = false;
                var getTransform = function (value) {
                    var prefixes = ['', '-webkit-', '-ms-'];
                    var css = '';
                    Array.prototype.forEach.call(prefixes, function (prefix) {
                        css += prefix + 'transform: scale(' + value.toFixed(4) + ',1);';
                    });
                    return css;
                };

                $window.on('scroll', c.throttle(function () {

                    curr_abs_pos = $window.scrollTop();
                    curr_blog_pos = curr_abs_pos - blog_entry_top;
                    curr_value = curr_blog_pos / blog_height;
                    curr_percent_val = curr_value * 100.0;

                    $('.progress-bar', $ProgressContainer).attr({style: getTransform(curr_value)});

                    if (curr_percent_val >= 0.0 && curr_percent_val <= 102.0 && !visible) {
                        $ProgressContainer.addClass('visible');
                        visible = true;
                    } else if ((curr_percent_val < 0.0 || curr_percent_val > 104.0) && visible) {
                        $ProgressContainer.removeClass('visible');
                        visible = false;
                    }
                }, 200));

                $window.resize(function () {
                    winHeight = $window.height();
                    blog_entry_top = $blogEntryTop.offset().top;
                    blog_entry_bottom = $blogEntryBottom.offset().top - winHeight;
                    blog_height = blog_entry_bottom - blog_entry_top;
                    $window.scroll();
                });

                $window.resize();

            })();
        }

        // Init Kundenbereich-Icon-Badge (nur wenn Element vorhanden)
        if ($('#HeaderAccountIconBadge').length) {
            this.accountBadge.init();
        }

        // Kundenbereich-Pop-ups ggf. anzeigen (nur wenn entsprechendes LocalStorage-Flag gesetzt und Popup existiert)
        if (c.sessionCookie.get('c_showFlashsalePopup') === '1' && $('#FlashsalePopup').length) {
            var name = c.sessionCookie.get('c_flashsalePopupName');
            var time = c.sessionCookie.get('c_flashsalePopupTime');
            var path = c.sessionCookie.get('c_flashsalePopupPath');
            this.accountBadge.showFlashsalePopup(name, time, path);
            c.sessionCookie.remove('c_showFlashsalePopup');
        }

        // Zuletzt gesehene Produkte mit Ambientebild auf der Startseite
        var $LastViewedBlock = $('#LastViewedBlock');
        if ($LastViewedBlock.find('.matrix a').length) {
            $LastViewedBlock.show();
        }

        // Neuheiten mit Ambientebild auf der Startseite
        var $NewProductsBlock = $('#NewProductsBlock');
        if ($NewProductsBlock.find('.list-products a').length) {
            $NewProductsBlock.show();
        }

        // Initialisierung Produkt-Erinnerungs-Block
        var $ProductReminderBlock = $('#ProductReminderBlock');
        if ($ProductReminderBlock.find('.list-products__item').length >= 4) {
            if (!$ProductReminderBlock.find('.list-products__item--cart').length) {
                var $ReminderToCartButton = $ProductReminderBlock.find('#ReminderToCartButton');
                $ReminderToCartButton.attr({
                    href: $ReminderToCartButton.data('wishlist-link'),
                    title: $ReminderToCartButton.data('wishlist-title')
                });
            }
            $ProductReminderBlock.show();
        }

        // Initialisierung Produktlisten - Umschalter Freisteller/Stimmungsbilder
        var $listproductsitem = $('.list-products__item > .productname');
        if ($listproductsitem.length) {
            $listproductsitem.each(function (i, v) {
                $(v).data('text', v.innerText);
            });
            $listproductsitem.shave(70);
            $(window).resize(function () {
                $listproductsitem.each(function (i, v) {
                    v.innerHTML = $(v).data('text');
                });
                $listproductsitem.shave(70);
            })
        }

        // Breadcrumbs nach dem Laden oder beim resize immer Rechtsbündig anzeigen
        var bc = document.querySelector('#breadcrumb');
        if (bc !== null) {
            $(window).on('load resize', function () {
                bc.scrollLeft = 9999;
            });
        }

        // Teaser Block Buttons zum Aufklappen auf Brand Shop Seiten in der Desktop-Ansicht
        var teaserButtons = document.querySelectorAll('.button-teaser-show');
        if (teaserButtons.length) {
            teaserButtons.forEach(function (teaserButton) {

                // Alle Halbtransparenten und Unsichtbaren vorab speichern
                var ParentSection = document.querySelector(teaserButton.dataset.parentSectionId);
                var hiddenElements = ParentSection.querySelectorAll('.max-tablet');
                var hollowElements = ParentSection.querySelectorAll('.teaser-wrapper__swiper--item--hollow');
                var notLoaded = true;

                teaserButton.addEventListener('click', function () {

                    // gerade im eingeklappten Modus?
                    var isInHiddenState = teaserButton.dataset.state === "hidden";

                    // versteckte Elemente ab 9. Element/3. Zeile, Sichtbarkeit in Desktop-Ansicht togglen
                    if (hiddenElements.length) {
                        hiddenElements.forEach(function (hiddenElement) {

                            // wenn eingeklappt: mit .max-tablet class in Desktop-Ansicht (min-height: 768px)
                            // unsichtbar machen, mobil kein Effekt, weil immer sichtbar und css-Slider
                            isInHiddenState
                                ? hiddenElement.classList.remove('max-tablet')
                                : hiddenElement.classList.add('max-tablet');
                        });

                        // bei erster Sichtbarkeit lazy load anstoßen
                        if (notLoaded && isInHiddenState) {
                            $(hiddenElements).lazyLoadXT();
                            notLoaded = false;
                        }
                    }

                    // halbtransparente Teaserelemente, 5.-8. Element in der zweiten Zeile, opacity in Desktop-Ansicht togglen
                    if (hollowElements.length) {
                        hollowElements.forEach(function (hollowElement) {

                            // wenn eingeklappt: mit '..--hollow' class in desktop (min-height: 768px)
                            // halbtransparent, mobil kein Effekt, weil komplett sichtbar und css-Slider
                            isInHiddenState
                                ? hollowElement.classList.remove('teaser-wrapper__swiper--item--hollow')
                                : hollowElement.classList.add('teaser-wrapper__swiper--item--hollow');
                        });
                    }

                    // hidden state und Wording togglen
                    if (isInHiddenState) {
                        teaserButton.dataset.state = "shown";
                        teaserButton.innerText = teaserButton.dataset.hideAllText;
                    } else {
                        teaserButton.dataset.state = "hidden";
                        teaserButton.innerText = teaserButton.dataset.showAllText;
                    }
                })
            })
        }
    },

    throttle: function (func, wait) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        var later = function () {
            previous = date_now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };

        var date_now = Date.now || function () {
            return new Date().getTime();
        };

        return function () {
            var now = date_now();
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    },

    revealPopup: function (selector) {
        $(selector).reveal({
            animation: 'fade',
            animationspeed: 200,
            closeonbackgroundclick: true
        });
    },

    initRatingForm: function (url, itemId) {
        $('#PluginContainer').load(url, function () {
            $('#ProductRatingFormContainer').find('#ItemId').val(itemId);
            const $form = $('form.validate');
            $form.validate({
                errorPlacement: function (error, element) {
                    if (element[0].name == "Rating") {
                        error.appendTo(element.parent().parent());
                    } else {
                        error.appendTo(element.parent());
                    }
                },
                rules: {
                    Rating: {
                        required: true
                    },
                    Subject: {
                        required: true,
                        minlength: 10
                    },
                    Content: {
                        required: true,
                        minlength: 150
                    }
                },
            });
        });
        $('#RatingPopup').reveal();
        return false;
    },

    initValidator: {
        messages: {
            de: {
                required: "Dies ist ein Pflichtfeld.",
                maxlength: $.validator.format("Geben Sie bitte maximal {0} Zeichen ein."),
                minlength: $.validator.format("Geben Sie bitte mindestens {0} Zeichen ein."),
                rangelength: $.validator.format("Geben Sie bitte mindestens {0} und maximal {1} Zeichen ein."),
                email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                url: "Bitte geben Sie eine gültige URL ein.",
                date: "Bitte geben Sie ein gültiges Datum ein.",
                number: "Bitte geben Sie eine Zahl ein.",
                digits: "Bitte geben Sie nur Ziffern ein.",
                equalTo: "Die Eingaben stimmen nicht überein.",
                range: $.validator.format("Geben Sie bitte einen Wert zwischen {0} und {1} ein."),
                max: $.validator.format("Geben Sie bitte einen Wert kleiner oder gleich {0} ein."),
                min: $.validator.format("Geben Sie bitte einen Wert größer oder gleich {0} ein."),
                creditcard: "Geben Sie bitte eine gültige Kreditkarten-Nummer ein."
            },
            da: {
                required: "Dette felt er påkrævet.",
                maxlength: $.validator.format("Indtast højst {0} tegn."),
                minlength: $.validator.format("Indtast mindst {0} tegn."),
                rangelength: $.validator.format("Indtast mindst {0} og højst {1} tegn."),
                email: "Indtast en gyldig email-adresse.",
                url: "Indtast en gyldig URL.",
                date: "Indtast en gyldig dato.",
                number: "Indtast et tal.",
                digits: "Indtast kun cifre.",
                equalTo: "Indtast den samme værdi igen.",
                range: $.validator.format("Angiv en værdi mellem {0} og {1}."),
                max: $.validator.format("Angiv en værdi der højst er {0}."),
                min: $.validator.format("Angiv en værdi der mindst er {0}."),
                creditcard: "Indtast et gyldigt kreditkortnummer."
            },
            fr: {
                required: "Ce champ est obligatoire.",
                remote: "Veuillez corriger ce champ.",
                email: "Veuillez fournir une adresse électronique valide.",
                url: "Veuillez fournir une adresse URL valide.",
                date: "Veuillez fournir une date valide.",
                dateISO: "Veuillez fournir une date valide (ISO).",
                number: "Veuillez fournir un numéro valide.",
                digits: "Veuillez fournir seulement des chiffres.",
                creditcard: "Veuillez fournir un numéro de carte de crédit valide.",
                equalTo: "Veuillez fournir encore la même valeur.",
                extension: "Veuillez fournir une valeur avec une extension valide.",
                maxlength: $.validator.format("Veuillez fournir au plus {0} caractères."),
                minlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
                rangelength: $.validator.format("Veuillez fournir une valeur qui contient entre {0} et {1} caractères."),
                range: $.validator.format("Veuillez fournir une valeur entre {0} et {1}."),
                max: $.validator.format("Veuillez fournir une valeur inférieure ou égale à {0}."),
                min: $.validator.format("Veuillez fournir une valeur supérieure ou égale à {0}."),
                maxWords: $.validator.format("Veuillez fournir au plus {0} mots."),
                minWords: $.validator.format("Veuillez fournir au moins {0} mots."),
                rangeWords: $.validator.format("Veuillez fournir entre {0} et {1} mots."),
                letterswithbasicpunc: "Veuillez fournir seulement des lettres et des signes de ponctuation.",
                alphanumeric: "Veuillez fournir seulement des lettres, nombres, espaces et soulignages.",
                lettersonly: "Veuillez fournir seulement des lettres.",
                nowhitespace: "Veuillez ne pas inscrire d'espaces blancs."
            }
        },

        init: function (lang) {
            var msgObj = this.messages[lang];

            // falls jemals 'require.js' verwendet wird, hier code aus
            // den 'jquery.validate.messages_{lang}.js' zur rate ziehen
            $.extend($.validator.messages, msgObj);
        }
    },

    accountBadge: {
        maxDisplayBadges: 3,
        init: function () {

            // Daten sammeln
            var c_CustomerIsLoginValidated = window.c_CustomerIsLoginValidated || false;
            var c_CustomerNewsletterFlag = window.c_CustomerNewsletterFlag || false;
            var c_FlashSaleDataPath = window.c_FlashSaleDataPath || '';

            // Prüfen, ob Flash-Sale-Pop-up eingeblendet werden muss. Voraussetzung:
            /* Hide-Flag darf noch nicht gesetzt sein
             * Kunde ist eingeloggt und hat Newsletter-Flag
             * Data-Path darf auf keinen Fall leer sein */
            var flashsaleBadgeCounter = c.sessionCookie.get('c_AccountFlashsaleBadgeShown') === false ? 0 : c.sessionCookie.get('c_AccountFlashsaleBadgeShown');
            var hideFlagSet = c.sessionCookie.get('c_hideHeaderFlashsaleBadge') !== false;

            if (hideFlagSet || !c_CustomerIsLoginValidated || !c_CustomerNewsletterFlag || c_FlashSaleDataPath == '' || flashsaleBadgeCounter >= 3) {
                return;
            }

            // Zuerst in der Localstorage nach Daten suchen und verarbeiten
            var sessionData = sessionStorage.getItem('c_FlashsaleData');
            if (sessionData !== null) {
                c.accountBadge.processFlashsaleData($.parseXML(sessionData));

                return;
            }

            // Falls nicht vorhanden, Daten vom FlashSaleDataPath holen und zwischenspeichern
            $.get(c_FlashSaleDataPath, function (data) {
                sessionStorage.setItem('c_FlashsaleData', data);
                c.accountBadge.processFlashsaleData($.parseXML(data));
            }, 'text');
        },

        processFlashsaleData: function (data) {
            // Daten durchgehen und Flashsale suchen, der innerhalb von 24 Stunden endet
            var endDates = $(data).find('EndDate');
            for (var i = 0; i < endDates.length; i++) {
                var $node = $(endDates[i]);
                var now = new Date();
                var end = new Date($node.text());
                var diff = Math.floor((end - now) / (1000 * 60 * 60));

                // Weitere Verarbeitung nur, wenn ein passender Flashsale gefunden wurde
                if (diff > 0 && diff < 24) {

                    // Counter prüfen, wie oft das Badge schon eingeblendet wurde
                    var flashsaleBadgeCounter = c.sessionCookie.get('c_AccountFlashsaleBadgeShown') === false ? 0 : c.sessionCookie.get('c_AccountFlashsaleBadgeShown');
                    if (flashsaleBadgeCounter < this.maxDisplayBadges) {

                        // Counter hochzählen
                        c.sessionCookie.set('c_AccountFlashsaleBadgeShown', ++flashsaleBadgeCounter);

                        // Metadaten des Flashsale aufbereiten und in der sessionStorage zwischenspeichern
                        var $sale = $node.parent();
                        var name = $sale.find('Headline').text();
                        var path = $sale.find('Path').text();

                        c.sessionCookie.set('c_flashsalePopupName', encodeURIComponent(name));
                        c.sessionCookie.set('c_flashsalePopupPath', encodeURIComponent(path));
                        c.sessionCookie.set('c_flashsalePopupTime', encodeURIComponent(diff));

                        // Badge einblenden und Event binden für Klick und Tracking
                        $('#HeaderAccountIconBadge').show();
                        $('#HeaderAccountIcon').on('click', function () {
                            c.tracking.sendEvent('trackFlashsaleBadgeClicked');
                            c.sessionCookie.set('c_hideHeaderFlashsaleBadge', '1');
                            c.sessionCookie.set('c_showFlashsalePopup', '1');
                        });

                    }

                    break;
                }
            }
        },

        showFlashsalePopup: function (name, remainingTime, path) {
            // Popup-Element selektieren
            var $FlashsalePopup = $('#FlashsalePopup');
            // Textplatzhalter im HTML ersetzen, um die korrekte Bezeichnung usw. anzuzeigen
            var popupHtml = $FlashsalePopup.html();
            popupHtml = popupHtml.replace('[[[SALE_NAME]]]', name);
            popupHtml = popupHtml.replace('[[[SALE_HOURS_REMAINING]]]', remainingTime);
            popupHtml = popupHtml.replace('[[[SALE_PATH]]]', path);
            popupHtml = popupHtml.replace(encodeURI('[[[SALE_PATH]]]'), path);
            $FlashsalePopup.html(popupHtml);
            // Popup einblenden
            $FlashsalePopup.reveal();
        }
    },

    blogNews: {
        init: function () {
            var $blogNewsDiv = $('#BlogNews');
            if ($blogNewsDiv.length) {

                var blogNewsData = sessionStorage.getItem('c_BlogNewsData');
                if (blogNewsData !== null) {
                    c.blogNews.fillSlots($blogNewsDiv, $.parseXML(blogNewsData));
                    return;
                }

                var c_BlogNewsDataPath = window.c_BlogNewsDataPath || '';
                if (c_BlogNewsDataPath != '') {
                    $.get(c_BlogNewsDataPath, function (data) {
                        sessionStorage.setItem('c_BlogNewsData', data);
                        c.blogNews.fillSlots($blogNewsDiv, $.parseXML(data));
                    }, 'text');
                } else {
                    $blogNewsDiv.closest('section').remove();
                }
            }
        },
        fillSlots: function ($blogNewsDiv, data) {

            var $blogNewsAnchors = $('a.list-products__item', $blogNewsDiv);
            var blogEntries = Array.from(data.getElementsByTagName('BlogEntry'));

            $blogNewsAnchors.each(function (i) {
                $(this).attr({
                    'href': $('Path', blogEntries[i]).text(),
                    'data-cid': $('CategoryId', blogEntries[i]).text(),
                    'data-ctid': $('CategoryTypeId', blogEntries[i]).text()
                });
                $(this).append($('Name', blogEntries[i]).text());
                $('img', this).attr('src', $('Banner', blogEntries[i]).text());
                $('img', this).attr('alt', $('ImgAltText', blogEntries[i]).text());
            });
            $blogNewsDiv.show();
        },
    },

    mainNavigation: {
        init: function () {
            // Zuerst Initial-State setzen: Navigation ist nicht geöffnet (nur mobil relevant)
            history.replaceState({navOpened: 0}, '');

            // lade Dropdowns der Hauptnavigation
            c.mainNavigation.loadNavigation();

            // Hauptnavigation öffnen (nur mobil relevant)
            $('#MobileNavButton').on('click', function () {
                c.mainNavigation.openHeader();
            });
            // Hauptnavigation schließen (nur mobil relevant)
            $('#MobileNavCloseButton').on('click', function () {
                // Das schließen läuft über den History-State, daher müssen wir hier nur einen Schritt zurück gehen
                history.back();
            });

            // "Vor"- und "Zurück"-Events abfangen und ggf. Navigation öffnen/schließen
            window.addEventListener('popstate', function (event) {
                // Sicherstellen, dass das Event gemäß Spezifikation befüllt ist, gibt sonst Probleme mit PhantomJS
                if (event.state !== null && event.state.navOpened !== null) {
                    if (event.state.navOpened === 1) {
                        $('header').addClass('open');
                    } else {
                        c.mainNavigation.closeSearch();
                        $('header').removeClass('open');
                    }
                }
            });

            // Suche-Dropdown öffnen (Desktop)
            $('#NavSearchButton').on('click', function () {
                c.mainNavigation.openSearch();
            });

            // Suchefeld öffnen (mobil)
            $('#HeaderSearchButton').on('click', function () {
                c.mainNavigation.openHeader();
                c.mainNavigation.openSearch();
                $('.autocomplete-suggestions').empty().css('display', '');
            });

            // Suche-Dropdown schließen
            $('#NavSearchCloseButton').on('click', function () {
                c.mainNavigation.closeSearch();
            });

            // Suche absenden
            $('#DropdownSearchButton').on('click', function () {
                $('#Search').submit();
            });

            // Navigations-Dropdowns öffnen und schließen
            if ($(window).width() >= c.config.breakpointTabletLarge) {
                /* Desktopansicht:
                 * HoverIntent sorgt für saubere UX: Menü wird nur geöffnet, wenn der Benutzer wirklich darauf zeigt,
                 * nicht wenn er nur schnell mit der Maus darüberfährt */
                $('header .nav-link-dropdown').hoverIntent({
                    over: function () {
                        // Bei HoverIntent: Menü öffnen
                        c.mainNavigation.openNavDropdown(this);
                    },
                    out: function () {
                        // Beim Verlassen, Menü schließen, aber erst nach timeout
                        $(this).find('.section-nav-dropdown').removeClass('nav-open');
                    },
                    interval: 50, // internes Prüfinterval für das HoverIntent-Script, 50 ms sorgt für gute "Responsiveness"
                    timeout: 400 // wenn die Maus das Menü verlässt, 400 ms warten vorm Schließen
                }).on('touchstart', function (e) {
                    // Außerdem: Beim antippen des Nav-Elements auf einem Touchscreen mit Tablet-Größe:
                    // Nav-Dropdown öffnen, anstatt Link zu folgen (wenn es nicht schon geöffnet ist)
                    if ($(this).find('.section-nav-dropdown').hasClass('nav-open')) {
                        return;
                    }
                    e.preventDefault();
                    c.mainNavigation.openNavDropdown(this);
                });
            } else {
                /* Mobilansicht:
                 * Nav-Dropdowns lassen sich beliebig auf- und zuklappen.
                 * Direktes anspringen der Links ist dafür nicht mehr möglich. */
                $('header .nav-link-dropdown .main-navigation-link').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    if ($this.closest('.nav-link-dropdown').find('.section-nav-dropdown').hasClass('nav-open')) {
                        c.mainNavigation.closeNav();
                    } else {
                        c.mainNavigation.openNavDropdown($this.closest('.nav-link-dropdown'));
                        var $header = $('header');
                        var scrollTarget = $this.position().top - 10;
                        if ($header.scrollTop() > scrollTarget) {
                            $header.scrollTop(scrollTarget);
                        }
                    }
                });
            }

            // key press handling
            $('body').on('keyup', function (e) {
                var code = e.keyCode || e.which;

                // Tab-Key abfangen um die Suche zu öffnen (aber nur wenn keine Navigation geöffnet und kein Input im Focus)
                if (code === 9 && $('input:focus, textarea:focus, select:focus, button:focus, .nav-open').length === 0) {
                    e.preventDefault();
                    c.mainNavigation.openSearch();
                }
                // Suche schließen wenn ESC gedrückt
                else if (code === 27 && $('.nav-open').length > 0) {
                    c.mainNavigation.closeSearch();
                    $('header').removeClass('open');
                }
            });
        },
        // Navigation Dropdowns aus der session, oder asynchron nachladen, wenn Main Navigation existiert
        loadNavigation: function () {
            var $navLinks = $('.nav-link-dropdown');
            if ($navLinks.length) {
                var navigationData = sessionStorage.getItem('c_NavigationData');
                if (navigationData !== null) {
                    c.mainNavigation.embedNavigation($navLinks, navigationData);
                } else {
                    var navigationDataPath = $navLinks.parent().data('dropdown-html-path');
                    $.get(navigationDataPath, function (navData) {
                        sessionStorage.setItem('c_NavigationData', navData);
                        c.mainNavigation.embedNavigation($navLinks, navData);
                    });
                }
            }
        },
        // Navigation Dropdowns ins aktuelle dom laden
        embedNavigation: function ($navLinks, navData) {
            var htmlData = $.parseHTML(navData);
            $navLinks.each(function (_, navLink) {
                var navLinkSelector = '#' + navLink.dataset.navLinkId + '>section';
                var domNode = $(htmlData).find(navLinkSelector);
                $(navLink).append(domNode);
            });
            var metaLinkDomNode = $(htmlData).find('div.nav-mobile-meta-links__element');
            $('.nav-mobile-meta-links').html(metaLinkDomNode);
        },
        openHeader: function () {
            $('header').addClass('open');
            // History-State setzen, damit der Zurück-Button des Browsers die Navigation schließen kann
            history.pushState({navOpened: 1}, '');
        },
        openSearch: function () {
            // Beim öffnen der Suche, zuerst evtl. geöffnete Menüs schließen
            c.mainNavigation.closeNav();
            // Suche öffnen, Buttons passend ein-/ausblenden
            $('.nav-search').addClass('searching');
            $('#NavDropdownSearch').addClass('nav-open');
            $('#NavSearchButton').hide();
            $('#NavSearchCloseButton').show();
            // Focus direkt ins Suchfeld und hinspringen (ggf. relevant in Mobilansicht)
            $('#SearchTerm').focus();
            $('header').scrollTop(0);
        },
        closeSearch: function () {
            // Suche schließen und Buttons passend ein-/ausblenden
            $('.nav-search').removeClass('searching');
            $('#NavDropdownSearch').removeClass('nav-open');
            $('#NavSearchButton').show();
            $('#NavSearchCloseButton').hide();
        },
        openNavDropdown: function (element) {
            // Beim öffnen eines Menüs: Zuerst sicherstellen, dass die Suche geschlossen ist
            c.mainNavigation.closeSearch();
            // Evtl. offene Navigation schließen, und neue Aufklappen
            c.mainNavigation.closeNav();
            $(element).find('.section-nav-dropdown').addClass('nav-open');
            // Mobile-Toggle-Button umschalten auf "schließen" (nur relevant für Mobilansicht)
            $(element).find('.main-navigation-link__mobile-toggle').addClass('main-navigation-link__mobile-toggle--close');
            // Tracking-Informationen an GTM senden
            c.tracking.setVariable('LastOpenedNavigation', $(element).find('> a').text());
            c.tracking.sendEvent('trackNavigationOpened');
            // Lazy-loading für Bilder innerhalb der Navigation starten
            $(element).find('img[data-src]').lazyLoadXT();
        },
        closeNav: function () {
            // Alle evtl. offenen Menüs schließen, außer das ggf. zuletzt angeklickte
            $('.section-nav-dropdown:not(.nav-last-opened)').removeClass('nav-open')
                .closest('.nav-link-dropdown').find('.main-navigation-link__mobile-toggle')
                .removeClass('main-navigation-link__mobile-toggle--close');
        }
    },

    cartFunctions: {
        init: function () {
            if ($('#Cart').length) {
                $('#DeliveryDetails select').on('change', function () {
                    this.form.submit();
                });
            }

            if ($('.cart-row-voucher-form').length) {
                $('.cart-row-voucher-form .voucher-line').on('click', function () {
                    $('.voucher-input').toggle();
                });
            }

            if ($('.birthday-picker').length) {
                var oldwidth = window.innerWidth;
                if (oldwidth < c.config.breakpointTabletLarge) {
                    $('#CustomerRemarkDiv').prepend($('.birthday-picker'));
                }
                $(window).resize(function () {
                    if (oldwidth >= c.config.breakpointTabletLarge && window.innerWidth < c.config.breakpointTabletLarge) {
                        $('#CustomerRemarkDiv').prepend($('.birthday-picker'));
                    } else if (oldwidth < c.config.breakpointTabletLarge && window.innerWidth >= c.config.breakpointTabletLarge) {
                        $('.misc-customer-info').prepend($('.birthday-picker'));
                    }
                    oldwidth = window.innerWidth;
                });

            }

        }
    },

    initProductReview: function () {
        var $list = $('.product-review-list');
        if (!$list.length) return;
        var $more = $list.find('.product-review-list__more');
        if (!$more.length) return;

        $more.show().on('click', function () {
            $list.addClass('show-all');
            $more.remove();
        });
    },

    /**
     * Geburtstags-Formularfelder initialisieren
     */
    initBirthday: function () {
        $('.BirthdayDay').on('change', function () {
            $('.BirthdayDay').val($(this).val());
            var newDate = $('.BirthdayYear').first().val() + '-' + $('.BirthdayMonth').first().val() + '-' + $('.BirthdayDay').first().val();
            if (newDate.length === 10) {
                $('#Birthday').val(newDate);
            } else {
                $('#Birthday').val('');
            }
        });
        $('.BirthdayMonth').on('change', function () {
            $('.BirthdayMonth').val($(this).val());
            var newDate = $('.BirthdayYear').first().val() + '-' + $('.BirthdayMonth').first().val() + '-' + $('.BirthdayDay').first().val();
            if (newDate.length === 10) {
                $('#Birthday').val(newDate);
            } else {
                $('#Birthday').val('');
            }
        });
        $('.BirthdayYear').on('change', function () {
            $('.BirthdayYear').val($(this).val());
            var newDate = $('.BirthdayYear').first().val() + '-' + $('.BirthdayMonth').first().val() + '-' + $('.BirthdayDay').first().val();
            if (newDate.length === 10) {
                $('#Birthday').val(newDate);
            } else {
                $('#Birthday').val('');
            }
        });
    },

    specialOffer: {
        init: function () {

            c.specialOffer.timerInit('.fill.flash-sale .flash-sale__timer');

            var $flashsaleOfferInBlog = $('.intext-link-box.sale');
            if ($flashsaleOfferInBlog.length) {
                // Zuerst in der Sessionstorage nach Daten suchen und verarbeiten
                var sessionData = sessionStorage.getItem('c_FlashsaleData');
                if (sessionData !== null) {
                    this.fillIntextLinkBox($flashsaleOfferInBlog, c.specialOffer.sortFlashsales($.parseXML(sessionData)));
                } else {
                    // Falls nicht vorhanden, Daten vom FlashSaleDataPath holen und zwischenspeichern
                    $.get(c_FlashSaleDataPath, function (data) {
                        sessionStorage.setItem('c_FlashsaleData', data);
                        c.specialOffer.fillIntextLinkBox($flashsaleOfferInBlog, c.specialOffer.sortFlashsales($.parseXML(data)));
                    }, 'text');
                }
            }

        },
        timerInit: function (timerQuery) {
            var $timer = $(timerQuery);
            if (!$timer.length) {
                return;
            }
            $timer.each(function () {
                var $this = $(this),
                    date = $this.data('end-date'),
                    day = $this.data('tmp-day'),
                    hour = $this.data('tmp-hour'),
                    minute = $this.data('tmp-minute'),
                    final = $this.data('end-message'),
                    templateDay = '<span class="offer-timer__day">%-D %!D:' + day + ';</span>',
                    templateHour = '<span class="offer-timer__hour">%-H %!H:' + hour + ';</span>',
                    templateMinute = '<span class="offer-timer__minute">%-M %!M:' + minute + ';</span>';

                var today = new Date();
                if (new Date(date) < today) {
                    $this.closest("a.flash-sale").remove();
                    return;
                }
                $this.countdown(date).on('update.countdown', function (e) {
                    var format;
                    if (e.elapsed) {
                        return;
                    }
                    if (e.offset.days > 0 || e.offset.weeks > 0 || e.offset.months > 0) {
                        format = templateDay + ' ' + templateHour;
                    } else if (e.offset.days === 0 && e.offset.hours > 0) {
                        format = templateHour + ' ' + templateMinute;
                    } else {
                        format = templateMinute;
                    }
                    $(this).html(e.strftime(format));
                }).on('finish.countdown', function (e) {
                    $this.closest('.flash-sale__timer-text').html(final);
                });
            });

        },

        fillIntextLinkBox: function ($flashsaleOfferInBlog, flashsales) {

            if (flashsales.length) {
                var nearest = flashsales[0];
                var $BlogCTAImg = $('BlogCTAImg', nearest);
                var $BlogCTAImg2x = $('BlogCTAImg2x', nearest);
                if ($BlogCTAImg.length) {
                    var attrObj = {
                        'src': $BlogCTAImg.text(),
                        'srcset': $BlogCTAImg.text() + ' 1x, ' + $BlogCTAImg2x.text() + ' 2x'
                    };
                    $flashsaleOfferInBlog.find('img').attr(attrObj);
                } else {
                    $flashsaleOfferInBlog.find('img').attr('src', $('Banner', nearest).text());
                }
                var $strong = $flashsaleOfferInBlog.find('strong');
                $strong.text("„" + $('Headline', nearest).text() + "” " + $strong.text());
                $flashsaleOfferInBlog.attr('href', $('Path', nearest).text());
            } else {
                $flashsaleOfferInBlog.remove();
            }

        },

        sortFlashsales: function (data) {

            var flashsale_collection = data.getElementsByTagName('FlashSale');
            var convertArray = [];
            var today = new Date();
            var year = today.getFullYear(),
                mon = today.getMonth() + 1 < 10 ? "0" + (today.getMonth() + 1) : today.getMonth() + 1,
                day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate(),
                hour = today.getHours() < 10 ? "0" + today.getHours() : today.getHours(),
                min = today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();

            var todayString = year + '/' + mon + '/' + day + ' ' + hour + ':' + min;

            for (var i = 0; i < flashsale_collection.length; i++) {
                if (flashsale_collection[i].getElementsByTagName('EndDate')[0].textContent > todayString) {
                    convertArray.push(flashsale_collection[i]);
                }
            }

            if (convertArray.length > 1) {
                convertArray.sort(function (a, b) {

                    var first = a.getElementsByTagName('EndDate')[0].textContent;
                    var second = b.getElementsByTagName('EndDate')[0].textContent;

                    if (first < second) {
                        return -1;
                    } else if (first > second) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            }
            return convertArray;
        }
    },

    dropDownText: {
        init: function () {
            var contents = $('.drop-content').hide(),
                drops = $('.drop-title').on('click', function () {
                    var $this = $(this);
                    $this.find('.h2').toggleClass('open');
                    $this.next('.drop-content').slideToggle()
                });

            contents.find('a').on('click', function (e) {
                var $this = $(this);
                var hash = $this.prop('hash');
                if (hash.length) {
                    if ($(hash).length) {
                        var $title = $(hash).closest('.drop-title');
                        document.location.hash = hash;
                        $title.find('.h2').addClass('open');
                        $title.next('.drop-content').slideDown();
                        $('html, body').animate({scrollTop: ($title.offset().top)}, 'fast');
                        e.preventDefault();
                    }
                }
            });

            if (document.location.hash) {
                $(document.location.hash).closest('.drop-title').find('.h2').addClass('open').end().next('.drop-content').slideDown()
            }
        }
    },

    accountDeletion: function ($form) {
        var $select = $form.find('select'),
            $text = $form.find('#ReasonText'),
            $otherBlock = $form.find('#Other'),
            $otherInput = $form.find('#OtherText'),
            prefix = $text.data('prefix');

        $select.on('change', function () {
            var $this = $(this);
            switch ($this.val()) {
                case 'none':
                    $otherBlock.hide();
                    $text.val('');
                    break;
                case 'other':
                    $text.val('');
                    $otherBlock.show();
                    break;
                default:
                    $otherBlock.hide();
                    $text.val(prefix + ' ' + $this.val());
            }
        });
        $otherInput.on('keyup', function () {
            $text.val(this.value.length > 3 ? prefix + ' ' + this.value : '');
        })
    },

    /*
     * Usage:
     * <form data-save="" >...
     *   <div data-save="FIELD_IDENTIFIER" >
     *       <input  />
     *   </div>
     *   <div data-save="FIELD_IDENTIFIER2" >
     *       <input  />
     *   </div>
     * </form>
     *
     * Bei Bedarf erweiterbar für andere Formulare.
     * Derzeit wird nur das aktuelle Formular gespeichert.
     *
     * (bool) useSession SessionStorage, sonst localStorage
     *
     * ck 12-03-2014
     */
    formStorage: function (useSession) {
        var useSession = typeof useSession !== 'undefined' ? useSession : false;
        var storageKey = 'FormStorage';

        if (!$('form[data-save]').length) {
            useSession ? sessionStorage.removeItem(storageKey) : localStorage.removeItem(storageKey);
            return;
        }

        var $form = $('form[data-save]'), $items = $form.find('[data-save]'),
            fromStorage = c.storage.get(storageKey, true);

        if (fromStorage) {
            $.each($items, function (index, element) {
                var $element = $(element);
                $element.find('input').val(fromStorage.value[$element.data('save')]);
            });
        }

        $form.on('submit', function () {
            var toStorage = {};
            $.each($items, function (index, element) {
                var $element = $(element);
                var $input = $element.find('input');
                toStorage[$element.data('save')] = $input.val();
            });
            c.storage.set(storageKey, toStorage, true);
        });
    },

    singleBasketCRO: {
        vouchers: [],
        itemCount: 0,
        totalAmount: 0,
        currency: 'EUR',
        execute: function () {
            var cartVisited = c.sessionCookie.get('cartVisited') ? c.sessionCookie.get('cartVisited') : 0;

            c.sessionCookie.set('cartVisited', ++cartVisited);

            if (cartVisited === 1 && this.isAllowed()) {
                c.sessionCookie.set('isEligibleForSingleBasketVoucher', 1);
            }

            if (c.sessionCookie.get('isEligibleForSingleBasketVoucher')) {
                this.showVoucher();
            }
        },
        isAllowed: function () {
            switch (this.currency) {
                case 'DKK':
                    return this.itemCount == 1 && this.totalAmount <= 2000;
                default:
                    return this.itemCount == 1 && this.totalAmount <= 250;
            }
        },
        showVoucher: function () {
            var myVoucher = this.vouchers[0];
            if (typeof myVoucher.code !== 'undefined' && typeof myVoucher.value !== 'undefined') {
                var $voucherBox = $('#CROVoucherBox');

                var boxHtmlContent = $voucherBox.html();
                boxHtmlContent = boxHtmlContent.replace('[[[VALUE]]]', myVoucher.value);
                boxHtmlContent = boxHtmlContent.replace('[[[CODE]]]', myVoucher.code);
                $voucherBox.html(boxHtmlContent);

                if (window.innerWidth < c.config.breakpointTablet) {
                    $voucherBox.insertBefore($('.top-checkout-button'));
                }

                $voucherBox.show();
                c.tracking.sendEvent('trackSingleBasketVoucherShown');
            }
        }
    }
};

window.c = c;

$(document).ready(function () {
    c.init({lang: $('body').data('lang')});
});
